export default __webpack_public_path__ + "static/media/11.26efab9b.jpg";